<template>
    <v-container>
        <Loader ref="Loader"></Loader>
        <h3 style="font-size: 2em;">{{ TranslateText("Send SMS")}}</h3>
        <br>
        <v-card class="elevation-20">
            <v-layout wrap>
                <v-flex xs2>
                    <v-text-field label="To" v-model="form.SendTo" single-line full-width hide-details @keyup.enter="addUserToSendList"></v-text-field>
                </v-flex>
                <v-flex xs10 class="text-xs-right">
                    <v-chip>
                        {{ form.ToList }}
                    </v-chip>
                </v-flex>
                <v-divider></v-divider>
                <v-flex xs12>
                    <v-divider></v-divider>
                    <v-textarea label="Message" v-model="form.Content" counter max="120" height="250px" full-width
                        multi-line single-line></v-textarea>
                </v-flex>
                <v-flex>
                    <v-layout justify-end>
                        <v-btn icon>
                            <v-icon color="primary" @click="sendEmail">send</v-icon>
                        </v-btn>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-card>
    </v-container>
</template>


<script>
    export default {
        data() {
            return {
                form: {
                    SendTo: null,
                    ToList: [],
                    Content: null
                }
            }
        },
        mounted() {
            let self = this;

        },
        methods: {
            fetchData() {
                let self = this;


            },
            sendEmail() {
                let self = this;
                var Request = self.form;

                self.$refs.Loader.show();
                self.post("clickatell/send", Request)
                    .then(res => {
                        self.$refs.Loader.hide();
                        console.log(res)
                    })
                    .catch(err => {
                        console.log(err);
                        self.$refs.Loader.hide()

                    });
                self.form = "";
            },
            addUserToSendList() {
                let self = this;

                self.form.ToList.push(self.form.SendTo);
                self.form.SendTo = "";
            },
        }
    }
</script>

<style>

</style>